/** 選択肢の ○ (radio) / □ (checkbox) 疑似マーカー (⑧)。builder/定義閲覧で共用。 */
// questionMeta から切り出した (PRODUCT_DEV-629)。QTYPE(オブジェクト定数)と同居していると
// Fast Refresh がその場更新できないため (react-refresh/only-export-components)。
export function OptionMark({ kind }: { kind: "radio" | "checkbox" }) {
  return (
    <span
      style={{
        width: 14,
        height: 14,
        flex: "none",
        borderRadius: kind === "radio" ? 9999 : 4,
        border: "1.5px solid #CBD5E1",
        background: "#fff",
      }}
    />
  );
}
